import { useEffect } from "react";

const useHotjar = (username: string, userRole: "admin" | string, portal: string, userCompanyId: string) => {
    useEffect(() => {
        const script = document.createElement("script");
        const variablesScript = document.createElement("script");
        if (!import.meta.env.DEV && userRole != "admin" && window.location.host === "manage.crealo.app") {
            if (!document.querySelector(".hotjar-script")) {
                script.className = "hotjar-script";
                script.innerHTML =
                    " (function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:3375030,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');";
                document.body.appendChild(script);
            }
            if (!document.querySelector(".hotjar-script-variables")) {
                variablesScript.className = "hotjar-script-variables";
                variablesScript.innerHTML = `window.hj('identify', '${username}', {
                    'UserCompanyId': '${userCompanyId}',
                    'AccountType': '${userRole}',
                    'PublisherType': '${portal}'
                });`;
                document.body.appendChild(variablesScript);
            }
        }

        return () => {
            if (document.querySelector(".hotjar-script")) {
                document.querySelector(".hotjar-script")?.remove();
            }
            if (document.querySelector(".hotjar-script-variables")) {
                document.querySelector(".hotjar-script-variables")?.remove();
            }
        };
    }, [username, userRole]);
};

export default useHotjar;
